import React from "react";
import {
  FormGroup as MuiFormGroup,
  FormControlLabel as MuiFormControllLabel,
  Checkbox as MuiCheckbox,
} from "@mui/material";

function CheckboxGroup({
  items = [], // object array
  row = false, // bool
  sx, // object
}) {
  return (
    <MuiFormGroup sx={sx} row={row}>
      {items.map((item, index) => {
        return (
          <MuiFormControllLabel
            key={index}
            sx={item.nameSx} // 폰트 크기 조정
            label={<span style={{ fontSize: "12px" }}>{item.name}</span>}
            disabled={item.disabled}
            labelPlacement={item.labelPlacement}
            control={
              <MuiCheckbox
                checked={item.checked}
                checkedIcon={item.checkedIcon}
                classes={item.classes}
                color={item.color}
                defaultChecked={item.defaultChecked}
                disableRipple={item.disableRipple}
                icon={item.icon}
                id={item.id}
                indeterminate={item.indeterminate}
                indeterminateIcon={item.indeterminateIcon}
                inputProps={item.inputProps}
                inputRef={item.inputRef}
                required={item.required}
                size={"small"}
                sx={item.sx}
                value={item.value}
                onChange={item.onChange}
              />
            }
          />
        );
      })}
    </MuiFormGroup>
  );
}

export default React.memo(CheckboxGroup);
